import { AllSelection, Plugin, TextSelection } from 'prosemirror-state';

export function limitSelectionToContentNodes() {
  return new Plugin({
    appendTransaction(transactions, oldState, newState) {
      const selection = newState.selection;
      const allSelection = new AllSelection(newState.doc);

      if (selection.eq(allSelection)) {
        return newState.tr.setSelection(
          TextSelection.create(newState.doc, 1, newState.doc.content.size - 1)
        );
      }

      return null;
    }
  });
}
